"use strict";
(self["webpackChunklittle_sleepies"] = self["webpackChunklittle_sleepies"] || []).push([[1634],{

/***/ 1634:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ fabricToggle)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function fabricToggle() {
  const settings = {
    fabricToggleSection: '[data-fabric-toggle-section]',
    fabricSectionWave: '[data-fabric-section-wave]',
    fabricToggle: '[data-fabric-toggle]',
    fabricRadio: '[data-fabric-radio]',
    playSection: '[data-play-section]',
    sleepSection: '[data-sleep-section]',
    newbornSection: '[data-newborn-section]',
  }

  ;(function init() {
    initializeEventListeners()
    updateCarouselAccessibility()
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('resize', updateCarouselAccessibility)
  })()

  function initializeEventListeners() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.fabricToggle).on('change', toggleFabric)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.fabricRadio).on('change', toggleFabricRadio)
  }

  function toggleFabric() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.fabricToggleSection).toggleClass('on')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.playSection).fadeToggle()
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.sleepSection).fadeToggle()

    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.fabricToggleSection).hasClass('on')) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.playSection).attr('aria-hidden', true)
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.sleepSection).attr('aria-hidden', false)
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.playSection).attr('aria-hidden', false)
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.sleepSection).attr('aria-hidden', true)
    }

    // Update carousel accessibility after toggle
    updateCarouselAccessibility()
  }

  function toggleFabricRadio() {
    const sectionToShow = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`${settings.fabricRadio}:checked`).val()

    if (sectionToShow === 'sleep') {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.fabricToggleSection).css('background-color', 'var(--sleep-bg-color)')
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.fabricSectionWave).find('path').attr('fill', 'var(--sleep-bg-color)')
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.sleepSection).attr('aria-hidden', false).fadeIn()
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.newbornSection).attr('aria-hidden', true).fadeOut()
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.playSection).attr('aria-hidden', true).fadeOut()
    } else if (sectionToShow === 'newborn') {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.fabricToggleSection).css('background-color', 'var(--newborn-bg-color)')
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.fabricSectionWave).find('path').attr('fill', 'var(--newborn-bg-color)')
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.newbornSection).attr('aria-hidden', false).fadeIn()
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.sleepSection).attr('aria-hidden', true).fadeOut()
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.playSection).attr('aria-hidden', true).fadeOut()
    } else if (sectionToShow === 'play') {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.fabricToggleSection).css('background-color', 'var(--play-bg-color)')
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.fabricSectionWave).find('path').attr('fill', 'var(--play-bg-color)')
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.playSection).attr('aria-hidden', false).fadeIn()
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.sleepSection).attr('aria-hidden', true).fadeOut()
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.newbornSection).attr('aria-hidden', true).fadeOut()
    }

    // Update carousel accessibility after toggle
    updateCarouselAccessibility()
  }

  function updateCarouselAccessibility() {
    const $fabricToggleSection = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.fabricToggleSection)
    if (!$fabricToggleSection.length) return

    const $carousels = $fabricToggleSection.find('[data-component="swiper"]')

    $carousels.each(function () {
      const $carousel = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
      const productCount = parseInt($carousel.data('product-count'))
      const isDesktop = window.innerWidth >= 1024
      const isVisible = !$carousel.closest('[aria-hidden="true"]').length

      if (isVisible) {
        // On desktop: remove "Carousel" if <= 4 products
        if (isDesktop && productCount <= 4) {
          const currentLabel = $carousel.attr('aria-label')
          const newLabel = currentLabel.replace(' Carousel', '')
          $carousel.attr('aria-label', newLabel)

          // Remove screen reader text from DOM
          $carousel.find('.carousel-sr-text').remove()
        } else {
          // Ensure screen reader text exists for mobile or when > 4 products
          if (!$carousel.find('.carousel-sr-text').length) {
            const $newSrText = jquery__WEBPACK_IMPORTED_MODULE_0___default()(
              '<p class="sr-only carousel-sr-text">This is a carousel with multiple slides. Use Next and Previous slide buttons, or your keyboard\'s left and right arrow buttons, to navigate.</p>'
            )
            $carousel.prepend($newSrText)
          }
        }

        // Update aria-labels on product cards
        setTimeout(() => {
          const $slides = $carousel.find('.swiper-slide[data-product-card]')
          $slides.each(function() {
            const $slide = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
            let currentLabel = $slide.attr('aria-label') || ''
            
            // Remove existing "Item " or "Slide " prefix if present
            currentLabel = currentLabel.replace(/^(Item|Slide)\s+/, '')
            
            // Add appropriate prefix based on carousel state
            if (isDesktop && productCount <= 4) {
              // Desktop with <= 4 products: use "Item"
              $slide.attr('aria-label', 'Item ' + currentLabel)
            } else {
              // Mobile or > 4 products: use "Slide"
              $slide.attr('aria-label', 'Slide ' + currentLabel)
            }
          })
        }, 100)
      }
    })
  }
}


/***/ })

}]);